import { render, staticRenderFns } from "./program-mapping.vue?vue&type=template&id=fb3bee12&scoped=true&"
import script from "./program-mapping.vue?vue&type=script&lang=ts&"
export * from "./program-mapping.vue?vue&type=script&lang=ts&"
import style0 from "./program-mapping.vue?vue&type=style&index=0&id=fb3bee12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3bee12",
  null
  
)

export default component.exports